import ItemWithTooltip from './ItemWithTooltip';
import { HomeMedIcon } from '../../../Icons';

interface Props {
  item: any;
}
const HomeMedItem = ({ item }: Props) => {
  return (
    <ItemWithTooltip item={item}>
      <div className="mt-2" />
      <HomeMedIcon />
    </ItemWithTooltip>
  );
};

export default HomeMedItem;
